import { Button, Form, Input, Modal, Select, message } from "antd";
import {
  useEditDriverMutation,
  useGetCarsQuery,
} from "../../../redux/Service/api";
import { useEffect } from "react";

const { Option } = Select;

const EditDriver = ({ setOpenModal, openModal, entity }: any) => {
  const [form] = Form.useForm();

  const {
    data: carsData,
    isError: isCarsError,
    isLoading: isCarsLoading,
  } = useGetCarsQuery(undefined);
  const cars = carsData?.ResponseObject ?? [];

  const [editDriver, { isLoading }] = useEditDriverMutation();

  useEffect(() => {
    form.setFieldsValue({
      DriverName: entity?.DriverName,
      Address: entity?.Address,
      Phone: entity?.Phone,
      CarId: entity?.CarId,
    });
  }, [entity]);

  const handleEditDriver = async (values: any) => {
    try {
      const updatedData = { ...values, DriverId: entity.DriverID };
      await editDriver(updatedData);
      message.success("تم تعديل السائق بنجاح");
      form.resetFields();
      setOpenModal(false);
    } catch (error) {
      console.error("خطأ أثناء تعديل السائق:", error);
      message.error("فشل في تعديل السائق. يرجى المحاولة مرة أخرى.");
    }
  };

  return (
    <Modal
      title="تعديل السائق"
      centered
      open={openModal}
      onCancel={() => {
        form.resetFields();
        setOpenModal(false);
      }}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleEditDriver}
        autoComplete="off"
      >
        <Form.Item
          label="اسم السائق"
          name="DriverName"
          rules={[{ required: true, message: "يرجى إدخال اسم السائق" }]}
        >
          <Input size="large" placeholder="أدخل اسم السائق" />
        </Form.Item>

        <Form.Item
          label="العنوان"
          name="Address"
          rules={[{ required: true, message: "يرجى إدخال العنوان" }]}
        >
          <Input size="large" placeholder="أدخل العنوان" />
        </Form.Item>

        <Form.Item
          label="رقم الهاتف"
          name="Phone"
          rules={[
            { required: true, message: "يرجى إدخال رقم الهاتف" },
            { pattern: /^[0-9]+$/, message: "يجب أن يحتوي على أرقام فقط" },
          ]}
        >
          <Input size="large" placeholder="أدخل رقم الهاتف" />
        </Form.Item>

        <Form.Item
          label="رقم السيارة"
          name="CarId"
          rules={[{ required: true, message: "يرجى اختيار رقم السيارة" }]}
        >
          {isCarsError ? (
            <div className="text-red-500">
              فشل في تحميل السيارات. يرجى المحاولة لاحقًا.
            </div>
          ) : (
            <Select
              size="large"
              placeholder="اختر رقم السيارة"
              loading={isCarsLoading}
            >
              {cars.map((car: any) => (
                <Option key={car.CarID} value={car.CarID}>
                  {car.CarNumber}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading} block>
            تعديل
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditDriver;
